import React from 'react';
import PropTypes from 'prop-types';

import { Flex, SvgIcon, Text } from 'Components/Base';

import AttachmentHeader from './AttachmentHeader';
import AttachmentItem, { ClearLoadingIcon } from './AttachmentItem';

const EmptyAttachment = () => {
  return (
    <Flex
      alignItems={'center'}
      color={'clear.clearGrayDark'}
      backgroundColor={'clear.clearGrayLight'}
      marginY={6}
      padding={4}
      style={{ borderRadius: 16 }}
    >
      <SvgIcon icon={SvgIcon.ICON_LIST.EMPTY_STATE_CLEAR_ICON} mr={4} />
      <Text textStyle={'body1'}>{'ไม่พบคำถามที่พบบ่อยในเนื้อหาส่วนนี้'}</Text>
    </Flex>
  );
};

const ClearAttachment = ({ attachments, setAttachmentSelected, attachmentHeader, isLoading }) => {
  return (
    <>
      <AttachmentHeader
        title={attachmentHeader.title}
        description={attachmentHeader.description}
        icon={attachmentHeader.icon}
      />
      {isLoading ? (
        <Flex height={'calc(100% - 64px)'} flex={1} alignItems={'center'} justifyContent={'center'}>
          <ClearLoadingIcon />
        </Flex>
      ) : attachments.length ? (
        attachments.map((attachment) => (
          <AttachmentItem
            key={attachment.id}
            title={attachment.title}
            mt={6}
            onClick={() => setAttachmentSelected(attachment)}
          />
        ))
      ) : (
        <EmptyAttachment />
      )}
    </>
  );
};

ClearAttachment.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      detail: PropTypes.string.isRequired,
    })
  ),
  attachmentHeader: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.func.isRequired,
  }),
  setAttachmentSelected: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default ClearAttachment;
